module.exports = __webpack_public_path__ + "img/rocket_tubes_box.b9f1811e.png";